import React from 'react';

import {AudienceTabChoice, TargetingsProps} from 'client/common/components/audience-settings/types';
import {useAudienceTargeting} from 'client/common/hooks/audience-targeting';
import {AudienceTargetingTabs} from 'client/common/utils/audience';

import TargetingTabStandard from './targeting-tab-standard';
import TargetingTabExtended from './targeting-tab-extended';
import TargetingTabsPreview from './targeting-tabs-preview';

function TargetingTabsWrapper(props: TargetingsProps) {
    const {
        boxType,
        request,
        categories,
        interests,
        isSelected,
        onChange,
        disabled,
        tab
    } = props;

    const {audienceTypeOptions} = useAudienceTargeting({
        boxType,
        request,
        categories,
        interests,
        onChange
    });

    if (!isSelected) {
        const labels =
            tab === AudienceTabChoice.Extended
                ? AudienceTargetingTabs.getExtendedTabPreviewLabels()
                : AudienceTargetingTabs.getStandardTabPreviewLabels(audienceTypeOptions);

        return <TargetingTabsPreview labels={labels} />;
    }

    const TargetingTab = tab === AudienceTabChoice.Extended ? TargetingTabExtended : TargetingTabStandard;

    return <TargetingTab
        boxType={boxType}
        categories={categories}
        disabled={disabled}
        interests={interests}
        request={request}
        onChange={onChange}
    />;
}

export default React.memo(TargetingTabsWrapper);
